module.exports = __webpack_public_path__ + "static/media/warning.ae42db8d.png";